import React from 'react';
import {Container} from "../../components/Container/Container";
import SideBar from '../../containers/SideBar/SideBar';
import { ChartHeader } from '../../components/ChartHeader/ChartHeader';


export const ChartHeaderLayout = ({children, chart, chartDetail, chartProject}) => {
    return <>
        <ChartHeader chartDetail={chartDetail} chartProject={chartProject}/>
        <SideBar/>
        <Container chart={chart}>
            {children}
        </Container>
    </>
}